import { RichUtils } from '../../common/model/rich-utils';
export class Characters {
}
Characters.PageBreak = RichUtils.specialCharacters.PageBreak;
Characters.LineBreak = RichUtils.specialCharacters.LineBreak;
Characters.ParagraphBreak = RichUtils.specialCharacters.ParagraphMark;
